module.exports = __webpack_public_path__ + "img/feature-3.ac6aea7.png";